export const MATCH_STATUS_CONFIG = {
    pending:   { color: "default",   label: "待匹配" },
    matched:   { color: "success",   label: "已匹配" },
    ambiguous: { color: "warning",   label: "待确认" },
    unmatched: { color: "error",     label: "未匹配" },
    manual:    { color: "blue",      label: "手动关联" },
    excluded:  { color: "purple",    label: "已排除" },
};

export const MATCH_STATUS_OPTIONS = Object.entries(MATCH_STATUS_CONFIG).map(
    ([k, v]) => ({ value: k, label: v.label }),
);
